import {
  CheckOutlined,
  CloseOutlined,
  DeleteOutlined,
  FileExcelOutlined,
  KeyOutlined,
  LockOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import {
  CommandBar,
  Persona,
  PersonaSize,
  SearchBox,
  Dialog,
  Toggle,
  DialogFooter,
  PrimaryButton,
  ProgressIndicator,
  Spinner,
  SpinnerSize,
} from "@fluentui/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import { SubPageHeaderTitle } from "../../../../shared/SubPageHeaderTitle";
import Moment from "react-moment";
import { observer } from "mobx-react-lite";
import AccountStore from "../store/accountStore";
import PermissionStore from "../../permission/store/permissionStore";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import {
  notification,
  Skeleton,
  List,
  Card,
  Space,
  Button,
  message,
  Switch,
} from "antd";
import { LockOut } from "./LockOut";
import confirm from "antd/lib/modal/confirm";
import { toJS } from "mobx";
const _ = require("underscore");
export const Accounts = observer(() => {
  const accountStore = useContext(AccountStore);
  const permissionStore = useContext(PermissionStore);
  const [state, setState] = useState({
    permissionDialogHidden: true,
    userRoles: [],
  });
  const gridApi = useRef(null);
  let pObjs = [];
  useEffect(() => {
    async function loadAllUsers() {
      try {
        await accountStore.loadAllUsers();
        if (!permissionStore.priviledges?.size) {
          await permissionStore.loadPriviledgesFromDB();
        }
      } catch (error) {
        notification.error({
          message: "SPARS Feedback",
          description: error.message,
        });
      }
    }
    loadAllUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const rowSelected = (grid) => {
    accountStore.userCommandBarDisabled = false;
    const selrow = grid.api.getSelectedNodes()[0];
    if (selrow) accountStore.selectedUser = toJS(selrow.data);
  };
  const grid = useRef(null);
  const gridcolumnDefs = {
    columnDefs: [
      {
        rowDrag: true,
        valueGetter: function (params) {
          return Number(params.node.id) + 1;
        },
        width: 80,
        sortable: true,
        resizable: true,
        checkboxSelection: true,
      },
      {
        headerName: "Name",
        field: "fullName",
        sortable: true,
        resizable: true,
        filter: true,

        cellRendererFramework: function (params) {
          return (
            <div>
              <Persona
                text={`${params.data.fullName}`}
                size={PersonaSize.size24}
                onRenderPrimaryText={(data) => {
                  return <span style={{ fontSize: "12px" }}>{data.text}</span>;
                }}
              />
            </div>
          );
        },
      },
      {
        headerName: "Email",
        field: "email",
        sortable: true,
        resizable: true,
        filter: true,
      },
      {
        headerName: "Status",
        field: "isEnabled",
        sortable: true,
        resizable: true,
        filter: true,
        width: 75,
        cellRendererFramework: function (props) {
          const { isEnabled } = props.data;
          return isEnabled ? (
            <CheckOutlined
              className="qicon"
              style={{ color: "green" }}
              title={`${props.data.fullName}  can access the system`}
            />
          ) : (
            <CloseOutlined
              className="qicon"
              style={{ color: "red" }}
              title={`${props.data.fullName}  has been locked out of the system`}
            />
          );
        },
      },
      {
        headerName: "Mobile",
        field: "phoneNumber",
        sortable: true,
        resizable: true,
        filter: true,
      },
      {
        headerName: "Office Extension",
        field: "extension",
        sortable: true,
        resizable: true,
        filter: true,
      },
      {
        headerName: "Job Function",
        field: "jobFunction",
        sortable: true,
        resizable: true,
        filter: true,
      },
      {
        headerName: "Department",
        field: "departmentName",
        sortable: true,
        resizable: true,
        filter: true,
      },
      {
        headerName: "Employee Category",
        field: "userType",
        sortable: true,
        resizable: true,
        filter: true,
      },
      {
        headerName: "Company",
        field: "company",
        sortable: true,
        resizable: true,
        filter: true,
      },
      {
        headerName: "Account Audit",
        children: [
          {
            headerName: "Last Logged-on",
            field: "lastAccessDate",
            sortable: true,
            resizable: true,

            width: 130,
            filter: true,
            cellRendererFramework: function (props) {
              const { lastAccessDate } = props.data;
              return (
                <span title={lastAccessDate}>
                  {" "}
                  {lastAccessDate && <Moment fromNow>{lastAccessDate}</Moment>}
                </span>
              );
            },
          },

          {
            headerName: "Created By",
            field: "createdBy",
            sortable: true,
            resizable: true,
            filter: true,
            width: 120,
          },
          {
            headerName: "Created On",
            field: "createdOn",
            sortable: true,
            resizable: true,
            filter: true,
            cellRendererFramework: function (props) {
              const { createdOn } = props.data;
              return (
                <span title={createdOn}>
                  {" "}
                  {createdOn && <Moment fromNow>{createdOn}</Moment>}
                </span>
              );
            },
            width: 120,
          },
        ],
      },
    ],
  };

  const closePermissionDialog = () => {
    setState({ ...state, permissionDialogHidden: true });
  };
  const handlePermissionsOpen = async () => {
    const seldata = gridApi.current?.getSelectedNodes()[0];
    if (!seldata) {
      notification.info({
        message: "SPARS Worflow Manager",
        description: "Please select a user",
      });
      return;
    }
    const { id } = toJS(seldata.data);

    try {
      const roles = await permissionStore.getUserRoles(id);

      setState({ ...state, permissionDialogHidden: false, userRoles: roles });
    } catch (err) {
      notification.error({
        message: "Feedback manager",
        description: err.message,
      });
    }
  };
  const handlePrivilegeSubmit = async (ev) => {
    try {
      const seldata = gridApi.current?.getSelectedNodes()[0];
      const { id } = toJS(seldata.data);

      /* [...permissionStore.priviledges.values()].forEach((p) => {
        pObjs.push({
          groupId: p.groupId,
          value: _.contains(_.pluck(state.userRoles, "groupId"), p.groupId),
          userId: accountStore.selectedUser?.id,
        });
      }); */

      const data = pObjs.map((d) => {
        return { ...d, userId: id };
      });
      console.log(data);
      await permissionStore.setUserPermisions(data);
      message.success("privileges assignment was successfull");

      closePermissionDialog();
    } catch (err) {
      notification.error({
        message: "Feedback manager",
        description: err.message,
      });
    } finally {
      permissionStore.isSettingUserPermission = false;
      accountStore.userCommandBarDisabled = true;
    }
  };
  return (
    <div className="ms-Grid tabcontainer" dir="ltr">
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <SubPageHeaderTitle
            count={accountStore.users.size}
            title={"SPARS User Accounts"}
          />
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <CommandBar
            items={[
              {
                key: "refresh",
                text: "Refresh",
                name: "New",
                onRenderIcon: () => <ReloadOutlined className="qicon" />,

                onClick: async () => {
                  accountStore.hasloadedUsers = false;
                  await accountStore.loadAllUsers();
                },
              },

              {
                key: "remove",
                text: "Remove",
                name: "delete",
                disabled: accountStore.userCommandBarDisabled,

                onRenderIcon: () => <DeleteOutlined className="qicon" />,
                onClick: () => {
                  const seldata = gridApi.current?.getSelectedNodes()[0];
                  console.log(seldata);

                  if (!seldata) {
                    notification.info({
                      message: "SPARS Feedback",
                      description: "select user to remove",
                    });
                    return;
                  }
                  accountStore.selectedUser = seldata.data;

                  const user = seldata.data;
                  const { fullName } = user;
                  confirm({
                    title: `Confirm delete ${fullName}?`,
                    content: `${fullName}  will be delete permanently and would not have access to this system anymore.`,
                    okText: "Yes",
                    okType: "danger",
                    cancelText: "No",
                    onOk: async () => {
                      try {
                        await accountStore.deleteUser(user.id);
                        notification.success({
                          message: "SPARS Feedback",
                          description: `${user.fullName} successfully removed from SPARS user list`,
                        });
                        accountStore.userCommandBarDisabled = true;
                      } catch (error) {
                        notification.info({
                          message: "SPARS Feedback",
                          description: "an error occured during the operation",
                        });
                      }
                    },
                    onCancel() {},
                  });
                },
              },

              {
                key: "access",
                text: "Lock-out...",
                name: "access",
                disabled: accountStore.userCommandBarDisabled,

                onRenderIcon: () => <KeyOutlined className="qicon" />,

                onClick: () => {
                  try {
                    const seldata = gridApi.current?.getSelectedNodes()[0];
                    console.log(seldata);

                    if (!seldata) {
                      notification.info({
                        message: "SPARS Feedback",
                        description: "select user to grant/deny access",
                      });
                      return;
                    }
                    accountStore.selectedUser = seldata.data;
                    accountStore.showLockOutDialog = true;
                  } catch (error) {}
                },
              },
              {
                key: "roles",
                text: "Manage Account group...",
                name: "access",

                onRenderIcon: () => <LockOutlined className="qicon" />,
                disabled: accountStore.userCommandBarDisabled,
                onClick: async () => await handlePermissionsOpen(),
              },
              {
                key: "spacer1",
                onRender: () => <div style={{ width: "50px" }} />,
              },
              {
                key: "search",
                onRender: () => (
                  <SearchBox
                    placeholder="Search"
                    styles={{
                      root: { width: "100%", borderBottomColor: "#CBD5E0" },
                    }}
                    underlined={true}
                    onChange={(ev, searchTerms) => {
                      gridApi.current?.setQuickFilter(searchTerms);
                      // const filterValue = grid.current.api.filterManager.quickFilter;
                    }}
                  ></SearchBox>
                ),
              },
            ]}
            farItems={[
              {
                key: "group4",
                text: "Export to Excel",
                name: "group",
                onRenderIcon: () => <FileExcelOutlined className="qicon" />,

                onClick: () => {
                  gridApi.current?.exportDataAsExcel();
                },
              },
            ]}
          />
        </div>
      </div>
      <div className="ms-Grid-row" style={{ paddingTop: "10px" }}>
        {accountStore.isloadingUsers ? (
          <>
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
          </>
        ) : (
          <div className="ms-Grid-col ms-sm12">
            {" "}
            <div
              className="ag-theme-balham"
              style={{
                minHeight: "50vh",
                height: "60vh",
                width: "100%",
                maxHeight: "80vh",
              }}
            >
              <AgGridReact
                rowData={[...accountStore.users.values()]}
                ref={grid}
                onGridReady={({ api }) => {
                  gridApi.current = api;
                }}
                gridOptions={{
                  defaultColDef: {
                    sortable: true,
                    filter: true,
                  },

                  rowSelection: "single",
                  pagination: true,
                  columnDefs: gridcolumnDefs.columnDefs,
                  animateRows: true,
                  statusBar: {
                    statusPanels: [
                      {
                        statusPanel: "agTotalRowCountComponent",
                        align: "center",
                      },
                    ],
                  },
                }}
                rowSelection="single"
                onSelectionChanged={rowSelected}
                copyHeadersToClipboard={true}
                overlayLoadingTemplate={`${(
                  <span class="ag-overlay-loading-center">
                    Please wait while your rows are loading
                  </span>
                )}`}
              ></AgGridReact>
            </div>
          </div>
        )}
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <LockOut />
        </div>
      </div>

      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12">
            <Dialog
              minWidth={700}
              hidden={state.permissionDialogHidden}
              onDismiss={closePermissionDialog}
              dialogContentProps={{
                title: `${accountStore.selectedUser?.fullName} Roles`,
                subText: `choose the account group to grant or rovoke ${accountStore.selectedUser?.fullName} access. `,
              }}
              modalProps={{
                isBlocking: false,
                styles: { main: { minWidth: 700 } },
                dragOptions: true,
              }}
            >
              <List
                grid={{
                  gutter: 16,
                  xs: 1,
                  sm: 2,
                  md: 4,
                  lg: 4,
                  xl: 6,
                  xxl: 2,
                }}
                dataSource={[...permissionStore.priviledges.values()]}
                renderItem={(item) => (
                  <List.Item>
                    <Card title={item.name + " group"}>
                      <div className="ms-Grid" dir="ltr">
                        <div className="ms-Grid-row">
                          <div className="ms-Grid-col ms-sm12">
                            {" "}
                            <Switch
                              checkedChildren="Deny"
                              unCheckedChildren="Grant"
                              defaultChecked={_.contains(
                                _.pluck(state.userRoles, "groupId"),
                                item.groupId
                              )}
                              onChange={(option, ev) => {
                                [
                                  ...permissionStore.priviledges.values(),
                                ].forEach((p) => {
                                  pObjs.push({
                                    groupId: p.groupId,
                                    value: _.contains(
                                      _.pluck(state.userRoles, "groupId"),
                                      p.groupId
                                    ),
                                    userId: accountStore.selectedUser?.id,
                                  });
                                });

                                pObjs.forEach((d) => {
                                  if (d.groupId === toJS(item.groupId)) {
                                    d.value = option;
                                  }
                                });
                                /* if(data.length){
  _.first(data).value = option;
} */
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </Card>
                  </List.Item>
                )}
              />
              <DialogFooter>
                <Space>
                  {permissionStore.isSettingUserPermission && (
                    <Spinner
                      label="saving, please wait..."
                      ariaLive="assertive"
                      labelPosition="right"
                      size={SpinnerSize.medium}
                    />
                  )}
                  <Button type="link" onClick={closePermissionDialog}>
                    Cancel
                  </Button>
                  <Button type="primary" onClick={handlePrivilegeSubmit}>
                    Save
                  </Button>
                </Space>
              </DialogFooter>
            </Dialog>
          </div>
        </div>
      </div>
    </div>
  );
});

